/**
 * функции для отрисовки одной страницы мэга для скриншотера
 */
import '../common/init';
import '../vendor/modernizr-2.8.3.js';
import '../libs/modernizr.tests.js';
import $ from '@rm/jquery';
import _ from '@rm/underscore';
import ViewerRouter from './router';
import { Utils } from '../common/utils';
import TextUtils from '../common/textutils';
import MagClass from './mag';
import Page from './page';
import { UserMagModel } from '../constructor/models/user-mag';
import '../../css/viewer_desktop.less';

$(function() {
  _.delay(function() {
    // Задержка, чтобы скриншотер после готовности страницы успел навесить свои хендлеры
    if (_.isEmpty(window.ServerData.mag)) {
      return ViewerRouter.prototype.sendReadyEvent.call(this, { error: 'No mag loaded. Deleted?' });
    }

    var exportPDFMode = Utils.queryUrlGetParam('pdf') == 'true';
    if (exportPDFMode) {
      Modernizr.retina = true;
    } // делаем pdf-ки всегда с ретина картинками

    var mag = (window.mag = window.ServerData.mag);
    mag = _.defaults(mag, MagClass.prototype);
    mag.model = new UserMagModel(mag, { parse: true });
    mag.router = ViewerRouter.prototype;
    mag.router.mag = mag;
    Modernizr.addTest('screenshot-mode', function() {
      return true;
    });
    Modernizr.addTest('screenshot-pdf-mode', function() {
      return exportPDFMode;
    });

    // Сформируем очень маленький шортлист только со шрифтами, которые используются в проекте.
    // Нужен в текстовом в методе seamlessFontsShow для устранения fout (и, возможно, других виджетах типа кнопки, в которых тоже есть текст).
    // (Через скриншотер происходит и экспорт в pdf, но при экспорте в pdf загружается обычный шортлист через fontsShortListCallback, смотреть в _singlepage.html)
    if (!exportPDFMode) {
      TextUtils.setShortList(TextUtils.getVeryShortList(mag.edit_params && mag.edit_params.fonts));
    }

    var split = window.location.href.split('?')[0].split('/');
    RM.screenshot = split[split.length - 1];

    document.title = RM.screenshot;

    var pageData = _.findWhere(mag.pages, { _id: RM.screenshot });
    if (_.isEmpty(pageData)) {
      return ViewerRouter.prototype.sendReadyEvent.call(this, { error: 'No page found. Deleted?' });
    }

    if (_.isEmpty(pageData)) return mag.router.sendReadyEvent({ error: true });

    var exportTemplateMode = Utils.queryUrlGetParam('template') == 'true';
    if (exportTemplateMode) {
      // Выбрасываем глоб. виджеты со страницы
      pageData.wids = _.filter(pageData.wids, function(w) {
        return !w.is_global;
      });
    } else {
      // Прицепляем все глобальные виджеты, найденные в в проекте
      var allGlobalWidgets = _(mag.pages)
        .chain()
        .reduce(function(wids, p) {
          return wids.concat(p.wids);
        }, [])
        .filter(function(w) {
          return w.is_global && w.pid !== pageData._id;
        }) // Свои глоб. виджеты страницы повторно добавлять не надо
        .map(function(w) {
          w.is_above = false;
          return w;
        }) // Сбрасываем свойство Above Pages, чтобы не мешалось
        .value();

      pageData.wids = pageData.wids.concat(allGlobalWidgets);
    }

    mag.$pages_container = $('#mags');
    mag.viewport = 'default';

    var page = new Page({
      mag: mag,
      router: mag.router,
      pageData: pageData,
      $container: mag.$pages_container,
    });

    page
      .render()
      .show()
      .loadForScreenshotMode();

    TextUtils.generateCSS('paragraph', 'viewer', document, mag.edit_params && mag.edit_params.paragraph_styles);
    TextUtils.generateCSS('link', 'viewer', document, mag.edit_params && mag.edit_params.link_styles);

    var fonts = TextUtils.getUsedFontsFromWidgetsModels({
      includeCustom: true,
      customList: _.filter(mag.edit_params && mag.edit_params.fonts, { provider: 'custom' }),
      models: page.widgets,
    });

    // загружаем только те шрифты вебтайпа, гугла и тайпкита, которые нашли на данной странице!
    // поиск шрифтов надо обязательно делать после textutils.generateCSS('paragraph', 'viewer', ...
    TextUtils.appendFontsCssToDocument({
      version: 'edit',
      fonts: fonts,
    });
  }, 100);
});
